function popupPersonalData() {
	// !Popups Personal-data
	if (document.querySelector('.personal-data--popup')) {
		let btnPass = document.querySelector('.Button--pass')
		let popup = document.querySelector('.personal-data--popup')
		let btnClose = document.querySelector('.Icon--close')

		const handler = () => {
			popup.classList.toggle('personal-data--popup-open')
			document.body.hasAttribute('style') ? document.body.removeAttribute('style') : (document.body.style = 'overflow: hidden;')
		}
		btnPass.onclick = btnClose.onclick = handler
		// !Validation Form
		let mainForm = document.querySelector('.personal-data__form')
		let mainFormInput = mainForm.querySelectorAll('.Input__inp')
		let btnSubmit = mainForm.querySelector("[type='submit']")
		mainFormInput.forEach(el => {
			el.onchange = () => {
				el.value ? el.classList.add('input-success') : el.classList.remove('input-success')
				if (mainForm.querySelectorAll('.input-success').length === mainFormInput.length) {
					btnSubmit.classList.remove('Button--disabled')
					btnSubmit.onsubmit = () => {}
				} else {
					btnSubmit.classList.add('Button--disabled')
				}
			}
		})
		let passForm = document.querySelector('.personal-data__wrapper')
		let passFormInput = passForm.querySelectorAll('.Input__inp--js')
		let btnSubmitPass = passForm.querySelector("[type='submit']")
		passFormInput.forEach(el => {
			el.oninput = () => {
				el.value ? el.classList.add('input-success') : el.classList.remove('input-success')
				if (passForm.querySelectorAll('.input-success').length === passFormInput.length) {
					if (passForm.querySelectorAll('.input-success')[1].value === passForm.querySelectorAll('.input-success')[2].value) {
						btnSubmitPass.classList.remove('Button--disabled')
						passForm.querySelector('[warning-validation]').removeAttribute('style')
					} else {
						passForm.querySelector('[warning-validation]').style.display = 'block'
						btnSubmitPass.classList.add('Button--disabled')
					}
				} else {
					btnSubmitPass.classList.add('Button--disabled')
				}
			}
		})
		// !Popups Orders
		let popupOrders = document.querySelectorAll('.personal-data--popup-orders')
		let btnPassOrders = document.querySelectorAll('.Table--pass-orders')

		popupOrders.forEach(el => {
			let btnCloseOrders = el.querySelector('.Icon--close-orders')
			btnCloseOrders.onclick = () => {
				el.classList.remove('personal-data--popup-orders-open')
				document.body.hasAttribute('style') ? document.body.removeAttribute('style') : (document.body.style = 'overflow: hidden;')
			}
		})
		btnPassOrders.forEach((el, id) => {
			el.onclick = () => {
				popupOrders[id].classList.add('personal-data--popup-orders-open')
				document.body.hasAttribute('style') ? document.body.removeAttribute('style') : (document.body.style = 'overflow: hidden;')
			}
		})
		let radioBtn = document.querySelector('.personal-data__form').querySelectorAll('[type="radio"]')

		radioBtn.forEach(el => {
			el.onclick = () => {
				radioBtn.forEach(i => i.removeAttribute('checked'))
				el.setAttribute('checked', '')
			}
		})
	}
}
// ! API
function outputMainForm(el) {
	let inp = el.querySelectorAll('input')
	let ouArray = new Array()
	// inp.forEach(item => {
	// 	ouArray.push(item.value)
	// })
	const obj = {
		oldPass: inp[0].value,
		newPass: inp[1].value,
		newPassSuccess: inp[2].value,
	}
	Api(obj, el.getAttribute('action'), el.querySelector('[data-status-success]'))
}

function infoFormPersonal(el) {
	let inp = el.querySelectorAll('input:not([type="radio"])')
	let radioBtn = el.querySelectorAll('[type="radio"]')
	let ouArray = new Array()
	inp.forEach(item => {
		ouArray.push(item.value)
	})
	radioBtn.forEach(item => {
		if (item.hasAttribute('checked')) {
			ouArray.push(item.value)
		}
	})
	
	Api({fName: ouArray[0], sName: ouArray[1], mName: ouArray[2], mail: ouArray[3], phone: ouArray[4], type: ouArray[5]}, el.getAttribute('action'), el.querySelector('[data-status-success]'))
}
function Api(arg, urlAddr, successMessage) {
	$.ajax({
		// url: '/ajax/changepass.php',
		url: urlAddr,
		method: 'post',
		dataType: 'json',
		data: arg,
		success: response => {
			if (response.status === 'success') {
				document.querySelector('[warning-oldPass]').removeAttribute('style')
				successMessage.removeAttribute('style')
			} else {
				document.querySelector('[warning-oldPass]').style.display = 'block'
			}
		},
		error: () => {},
	})
}
